import { Inject, Injectable } from '@angular/core';
import { UserSession } from '../models';
import { USER_SESSION_TOKEN } from '../user-access/user-session.token';
import { CryptoJSUtilityLib, StorageUtilityLib } from './index';

/**
 *  This method will use for all session management work.
 *
 * @export
 * @class AuthenticationLib
 */
@Injectable()
export class AuthenticationLib {
  constructor(
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private storageUtilityLib: StorageUtilityLib,
    private cryptoJSUtilityLib: CryptoJSUtilityLib,
  ) {}

  /**
   * Create the user session and store the user object in corresponding storage
   *
   * @param {*} data
   * @returns
   *
   * @memberOf AuthenticationLib
   */
  createUserSession(data: UserSession) {
    this.storageUtilityLib.setLocalStorage(this.userSessionToken, data);
    return;
  }

  /**
   * This method append the key in existing user session
   *
   * @param {*} data
   * @memberof AuthenticationLib
   */
  updateUserSession(data: UserSession) {
    let userSessionObject = this.storageUtilityLib.getLocalStorage<UserSession>(this.userSessionToken);
    userSessionObject = Object.assign(userSessionObject, data);
    this.createUserSession(userSessionObject);
  }

  /**
   *  This method retrieve user session from corresponding storage
   *
   * @returns { User session Object }
   *
   * @memberOf AuthenticationLib
   */
  checkUserSession(): UserSession | null {
    return this.storageUtilityLib.getLocalStorageNullable<UserSession>(this.userSessionToken);
  }

  /**
   *  This method check user is logged in or not
   *  This method also check user session is active or not
   *
   * @returns {boolean}
   *
   * @memberOf AuthenticationLib
   */
  isUserSessionActive(): boolean {
    const userObject = this.checkUserSession();
    return userObject && userObject.access_token ? true : false;
  }

  authorizedRoute(): boolean {
    return this.isUserSessionActive();
  }

  /**
   * Logout the user
   *
   * @memberOf AuthenticationLib
   */
  logout(): void {
    // clear the user session
    this.storageUtilityLib.clearLocalStorage(this.userSessionToken);
    this.storageUtilityLib.clearAllLocalStorage();
  }

  /**
   * This method convert all inputs to base64 encryption
   *
   * @param {string} token
   * @returns {string}
   * @memberof AuthenticationLib
   */
  getTokenEncoding(token: string): string {
    return this.cryptoJSUtilityLib.encodeBASE64(token);
  }
}
